document.addEventListener('DOMContentLoaded', () => {
  const defaultLanguageInput = document.querySelector('input#user_default_language');

  if (!defaultLanguageInput) {
    return;
  }

  const defaultLanguage = getCurrentLocale();
  defaultLanguageInput.value = defaultLanguage;
});
